import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type ToggleInputProps = Omit<FormInputProps, "formLayout">;

export const ToggleInput: React.FC<ToggleInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolvedValue = (): boolean => {
    const e = formData[formItem.name];
    if (!e) return false;
    else return e as boolean;
  };
  return (
    <div className="_toggle-input.tsx toggle-input">
      <FormControlLabel
        control={
          <Switch
            id={formItem.name}
            checked={resolvedValue()}
            onChange={(evt) => setValue(evt.target.checked)}
            disabled={formItem.disabled}
          />
        }
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
      />
    </div>
  );
};
